const thMessages = require("../locales/th_TH.json");
const thLang = {
  messages: {
    ...thMessages,
  },
  commingSoon: {
    header: "โครงการ Eastspring Wealth Privilege ประจำปี 2565 ได้สิ้นสุดลงแล้ว เมื่อวันที่ 31 ธันวาคม 2565",
    message: "เตรียมพบกับสิทธิพิเศษจากโครงการประจำปี 2566 เร็วๆนี้"
  },
  locale: "th-TH",
};
export default thLang;
